export default __webpack_public_path__ + "static/media/coresanscr65-webfont.091a8762.woff";